var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M6 5.6h42v28.8H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M6 5.6h42L6 34.4h42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M27 24.8a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m27 15.6-1.4 4.2 2.1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m27 15.6 1.4 4.2-2.1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M31.2 18.6h-4.4v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m31.2 18.6-3.6 2.6-1.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m29.6 23.6-1.4-4.2-2 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M29.6 23.6 26 21l1.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M24.4 23.6 28 21l-1.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m24.4 23.6 1.4-4.2 2 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m22.8 18.6 3.6 2.6 1.3-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M22.8 18.6h4.4v2.2M16.1.2l-.8 2.5 1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m16.1.2.8 2.5-1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M18.6 2H16v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m18.6 2-2 1.5-.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m17.7 4.9-.8-2.5-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m17.7 4.9-2.1-1.5.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m14.6 4.9 2.1-1.5-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m14.6 4.9.8-2.5 1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m13.7 2 2 1.5.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M13.7 2h2.6v1.3M27 .2l-.8 2.5 1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m27 .2.8 2.5-1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M29.5 2h-2.6v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m29.5 2-2.1 1.5-.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m28.5 4.9-.8-2.5-1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m28.5 4.9-2-1.5.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m25.5 4.9 2-1.5-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m25.5 4.9.8-2.5 1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m24.5 2 2.1 1.5.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M24.5 2h2.6v1.3M37.9.2 37 2.7l1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m37.9.2.8 2.5-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M40.3 2h-2.6v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m40.3 2-2 1.5-.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m39.4 4.9-.8-2.5-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m39.4 4.9-2.1-1.5.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m36.3 4.9 2.1-1.5-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m36.3 4.9.8-2.5 1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m35.4 2 2 1.5.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M35.4 2H38v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M8.9 20a7 7 0 0 0 2.7 2.8q0-2-.9-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M7.8 16.2c1 1.8-2.2 6.2 3 7.2q-1-1.6-1-3.5 2 .8 2.8 2.6c1.4-5-3.5-4.7-4.8-6.3m8.3 18.6-.8 2.4 1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m16.1 34.8.8 2.4-1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M18.6 36.5H16v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m18.6 36.5-2 1.6-.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m17.7 39.5-.8-2.5-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m17.7 39.5-2.1-1.6.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m14.6 39.5 2.1-1.6-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m14.6 39.5.8-2.5 1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m13.7 36.5 2 1.6.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M13.7 36.5h2.6v1.3m10.7-3-.8 2.4 1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m27 34.8.8 2.4-1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M29.5 36.5h-2.6v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m29.5 36.5-2.1 1.6-.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m28.5 39.5-.8-2.5-1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m28.5 39.5-2-1.6.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m25.5 39.5 2-1.6-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m25.5 39.5.8-2.5 1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m24.5 36.5 2.1 1.6.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M24.5 36.5h2.6v1.3m10.8-3-.8 2.4 1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m37.9 34.8.8 2.4-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M40.3 36.5h-2.6v1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m40.3 36.5-2 1.6-.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m39.4 39.5-.8-2.5-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m39.4 39.5-2.1-1.6.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m36.3 39.5 2.1-1.6-.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m36.3 39.5.8-2.5 1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m35.4 36.5 2 1.6.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M35.4 36.5H38v1.3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.eae439cd08fc4709c049e29a12927f80.svg";
export { ForwardRef as ReactComponent };